<template lang="pug">
  v-layout
    v-flex(style="width:4em;display: flex;")
      .box-inicial-beneficiario(
        :class="activarContingenciaMethod"
        )
        span(style="color:#ffffff;font-size:24px;line-height:initial;") {{nombreBeneficiario[0]}}
    v-flex(style="margin-left: 0.3em;")
      v-layout.box-text-beneficiario(column)
        v-flex
          span Beneficiario {{numeroBeneficiario || '1'}}
          span {{nombreBeneficiario.toLowerCase() || 'Nombre Apellido'}}
          span(style=";color: #EA0D90;font-weight: 500;") {{porcentajeBeneficio || '0'}}%
</template>

<script>
export default {
  props: [
    'iconBeneficiario',
    'numeroBeneficiario',
    'nombreBeneficiario',
    'porcentajeBeneficio',
    'activo'
  ],
  computed: {
    activarContingenciaMethod () {
      return this.activo ? 'box-activar-contingente' : ''
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 360px) {
  .box-inicial-beneficiario {
    height: 3.5em;
    width: 3.5em;
    margin: auto;
    background: #0855C4;
    border-radius: 3em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .box-inicial-beneficiario span {
    font-size: 30px !important;
  }

  .box-text-beneficiario {
    line-height: normal;
  }

  .box-text-beneficiario span {
    font-size: 15px;
    align-items: center;
    color: var(--text-color);
    font-weight: 600 !important;
    display: block;
    text-transform: capitalize;
    margin:0.2em 0em
  }

  .box-activar-contingente {
    background: var(--green-color) !important;
  }
}

@media screen and (min-width: 1200px) {
  .box-text-beneficiario span {
    font-size: 12px !important;
  }

  .box-inicial-beneficiario {
    height: 3em !important;
    width: 3em !important;
  }
  .box-inicial-beneficiario span {
    font-size: 24px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/generic/TarjetaBeneficiarioIconDetalle.vue